<template>
    <!-- Legado -->
    <div class="card" style="padding: 0px;">
        <div class="card-header d-flex justify-content-between alert-primary">
            <div>
            <div>
                <span v-if="side">
                    <i class="far fa-calendar-alt mr-2"></i>
                    {{ getHumanDate(item.dt_data) }} |
                    <span>{{ getHumanDay(item.dt_data) }}</span> |
                    <small>{{ getHumanDuration(item.dt_data) }}</small>
                </span>
                <a class="card-link" data-toggle="collapse" :href="'#collapse-leg-' + idx" role="button" v-else>
                    <i class="far fa-calendar-alt mr-2"></i>
                    {{ getHumanDate(item.dt_data) }} |
                    <span>{{ getHumanDay(item.dt_data) }}</span> |
                    <small>{{ getHumanDuration(item.dt_data) }}</small>
                </a>
            </div>
            <div>
                <i class="fas fa-history mr-2"></i>
                <small>{{ item.dt_data.substr(11,5) }}</small>
            </div>
            </div>
            <div class="text-right">
            <div>{{ item.st_descricao }}</div>
            <small>{{ item.st_nome_medico }}</small>
            </div>
        </div>

        <div class="collapse collapse-pep" :class="expandido ? 'show' : ''" :id="'collapse-leg-' + idx">
            <div class="card-body">

                <p v-if="item.st_observacao" class="alert alert-secondary py-2 small">
                    {{ item.st_observacao }}
                </p>

                <template v-if="item.st_tipo && item.st_tipo == 77 && item.form">

                    <campos-formulario 
                        :gutters="item.modelo ? item.modelo.fl_espaco_reduzido : false"
                        :tamanho="tamanho"
                        v-model="item.form"
                        :modelo="item.modelo"
                        :raiz="true" 
                        mode="view" />

                    <template v-if="item.html">
                        <hr>
                        <span v-html="item.html" class="lead legadoitem"></span>
                    </template>

                </template>

                <template v-else>
                    <span v-html="item.st_conteudo" class="lead legadoitem"></span>
                </template>

                <!-- Anexos -->
                <div v-if="item.arquivos.length">
                    <span v-for="(arq, iax) in item.arquivos" :key="iax">
                        <a :href="arq.arquivo.temporary_url" class="text-white" :key="iax" target="_blank">
                            <span class="badge badge-primary p-2 mr-2 mb-2">
                                <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                {{ arq.arquivo.st_titulo }}  
                            </span>
                        </a>
                        <a href="#" class="btn btn-outline-danger btn-sm" :key="iax + 'r'" v-if="$store.state.user.id_usuario == 1" @click.prevent="remover_anexo(arq)">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </a>
                    </span>
                </div>

                <div class="alert alert-info mt-3 mb-0 py-2" v-if="manual && item.st_an">
                    Accession Number: <strong>{{ item.st_an }}</strong>
                </div>

                <slot></slot>
            </div>

            <div class="card-footer" v-if="$store.state.user.id_usuario == 1 && !manual">
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="enviar_arquivo(item)">
                    Anexar
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import * as moment from "moment";
import CamposFormulario from './CamposFormulario.vue';

export default {
    data() { 
        return { 
            expandido: true, 
        };
    },
    
    components: { 
        CamposFormulario, 
    },

    props: ['item', 'idx', 'tamanho', 'pode_atender', 'side', 'manual'],

    methods: { 
        enviar_arquivo(pl) { 
            this.$emit('enviar_arquivo', pl);
        },

        remover_anexo(arq) { 
            this.$emit('remover_anexo', arq);
        },
        
        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },

        getHumanDate(date) {
            return (
                moment(date, "YYYY-MM-DD").format("DD") +
                " de " +
                moment(date, "YYYY-MM-DD").format("MMMM") +
                (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
                ? ""
                : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
            );
        },
        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) 
                return "hoje";
            else
                return moment.duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje())).humanize(true);
        },
    }
}
</script>